import React from 'react';

import BaseFilterChip from './BaseFilterChip';

type Props = {
  value?: string | null;
  onDelete: () => void;
};
export default function EventTypeFilterChip({ value, onDelete }: Props) {
  switch (value) {
    case 'DELIVERED':
      return <BaseFilterChip label="Delivered" onDelete={onDelete} />;
    case 'OPENED':
      return <BaseFilterChip label="Opened" onDelete={onDelete} />;
    case 'CLICKED':
      return <BaseFilterChip label="Clicked" onDelete={onDelete} />;
    case 'BOUNCED':
      return <BaseFilterChip label="Bounced" onDelete={onDelete} />;
    case 'COMPLAINED':
      return <BaseFilterChip label="Complained" onDelete={onDelete} />;
    case 'ERRORED':
      return <BaseFilterChip label="Errored" onDelete={onDelete} />;
    case 'ALL':
    default:
      return null;
  }
}
